{
  "name": "@jefuriiij/synthra",
  "version": "0.14.0",
  "publishConfig": {
    "access": "public"
  },
  "description": "Local context engine for AI coding assistants — graph-based context, branch-aware memory, real-time human-activity awareness, deterministic Grep/Glob gating, and a live token dashboard.",
  "type": "module",
  "bin": {
    "syn": "bin/syn",
    "synthra": "bin/syn"
  },
  "scripts": {
    "build": "npm run build:ui && tsup",
    "build:ui": "vite build --config vite.config.dashboard.ts",
    "dev": "tsup --watch",
    "dev:ui": "vite --config vite.config.dashboard.ts",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "typecheck": "tsc --noEmit",
    "lint": "biome lint .",
    "format": "biome format --write .",
    "check": "biome check .",
    "check:fix": "biome check --write ."
  },
  "files": [
    "dist",
    "bin",
    "README.md",
    "CHANGELOG.md",
    "LICENSE",
    "ROADMAP.md"
  ],
  "keywords": [
    "claude-code",
    "mcp",
    "context-engine",
    "code-graph",
    "ai-coding",
    "token-savings"
  ],
  "author": "Jeff (@jefuriiij)",
  "license": "MIT",
  "homepage": "https://github.com/jefuriiij/synthra#readme",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/jefuriiij/synthra.git"
  },
  "bugs": {
    "url": "https://github.com/jefuriiij/synthra/issues"
  },
  "engines": {
    "node": ">=18"
  },
  "dependencies": {
    "@hono/node-server": "^1.18.0",
    "chokidar": "^5.0.0",
    "cross-spawn": "^7.0.6",
    "hono": "^4.12.23",
    "ignore": "^7.0.0",
    "sade": "^1.8.1",
    "tree-sitter-wasms": "^0.1.12",
    "web-tree-sitter": "^0.25.10"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.4.16",
    "@lucide/svelte": "^1.18.0",
    "@sveltejs/vite-plugin-svelte": "^7.1.2",
    "@tailwindcss/vite": "^4.3.1",
    "@types/cross-spawn": "^6.0.6",
    "@types/node": "^25.9.1",
    "@vitest/coverage-v8": "^4.1.8",
    "bits-ui": "^2.18.1",
    "clsx": "^2.1.1",
    "svelte": "^5.56.3",
    "tailwind-merge": "^3.6.0",
    "tailwind-variants": "^3.2.2",
    "tailwindcss": "^4.3.1",
    "tsup": "^8.5.1",
    "tw-animate-css": "^1.4.0",
    "typescript": "^6.0.3",
    "vite": "^8.0.16",
    "vite-plugin-singlefile": "^2.3.3",
    "vitest": "^4.1.7"
  }
}
